export default [
  {
    path: '/email-config-plataforma',
    name: 'emailconfigplataform',
    component: () => import('@/app-modulo/plataforma/email-config/EmailConfiguracao.vue'),
    meta: {
      resource: 'email',
      action: 'create',
      pageTitle: 'Configurações de E-mails da plataforma',
      breadcrumb: [],
    },
  },
]
